<template>
	<div ref="container" style="width: 100%; height: 100%;"></div>
</template>

<script>
import LatestEventWidget from '@/widgets/LatestEventWidget';

export default {
	name: 'LatestEventWidgetPreview',
	props: {
		settings:          { type: Object, default: () => ({}) },
		sampleName:        { type: String,  default: 'ExampleUser' },
		sampleAmount:      { type: Number,  default: null },
		sampleAvatar:      { type: String,  default: '/img/avatars/luna_star.jpg' },
		sampleServiceIcon: { type: String,  default: '/img/logo3.png' },
	},
	watch: {
		settings: {
			deep: true,
			handler(s) { if(this.widget) this.widget.applySettings({ ...s }); },
		},
	},
	mounted() {
		this.widget = new LatestEventWidget({
			container: this.$refs.container,
			eventFilter: () => true,
		});
		this.widget.init({ settings: { ...this.settings } }).then(() => {
			this.widget.onAlert({
				message: {
					sender:            { displayName: this.sampleName, avatar: this.sampleAvatar },
					convertedValue:    this.sampleAmount,
					convertedCurrency: this.settings.currency_code || 'USD',
					serviceIconUrl:    this.sampleServiceIcon,
				},
			});
		});
	},
	beforeDestroy() {
		if(this.widget) {
			this.widget.destroy();
			this.widget = null;
			if(this.$refs.container) this.$refs.container.innerHTML = '';
		}
	},
};
</script>
